import { Component } from '@angular/core';
import { NavigationItems } from 'app/layout/service/app.navigation.service';
import { AuthUser } from 'app/shared/auth.service';
import { DomainService } from 'app/shared/domain.service';

@Component({
    selector: 'in-process',
    templateUrl: './in-process.component.html',
    standalone: false
})
export class InProcessComponent {
  user: AuthUser;
  NavigationItems = NavigationItems; // to make it available in the template
  constructor(
    protected domainService: DomainService,
    
  ) {

    
  }

  goBack() {
    this.domainService.location.back();
  }
  
}
